export const headerCartProps = () => ({
  total: {
    type: [String, Number],
    required: false,
    default: "0,00"
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false
  }
})